module.exports = __webpack_public_path__ + "img/personal-account.ebe20502.svg";